import React from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'

const ResetSuccessfull = () => {
    let navigate = useNavigate()
    const year = new Date().getFullYear();

        const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
    return (
        <>
            {/* <div className="login">
                <div className="d-lg-flex half">
                    <div className="bg order-1 order-md-2">
                        <img src={process.env.PUBLIC_URL + "/assets/images/v2LoginHMS.jpg"} alt="" />
                    </div>
                    <div className="contents order-2 order-md-1">
                        <h1 className="hk-title">Practice Management System</h1>
                        <div className="container hk-form-t">
                            <div className="row align-items-start justify-content-center">
                                <div className="col-md-8 d-flex flex-column justify-content-center text-center">
                                    <div className="hk-t-img">
                                        <img src={process.env.PUBLIC_URL + "/assets/images/lock-password.png"} alt="confirm email icon" />
                                    </div>
                                    <h2 class="heading xl text-center">Password reset</h2>
                                    <p className="text clr-muted text-center mt-3 forget-p">Your password has been successfully reset.<br /> Click below to log in.</p>
                                    <button className="btn rounded btn-blue w-100 mt-4 reset-pass-btn mt-5" onClick={() => navigate("../", { replace: true })}>
                                        Continue
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="ar_login-screen">
                <div className="ar-main-screen-content w-100 d-flex align-items-center flex-column gap-25 justify-content-center">
                    <div className="login-content">
                        <div className="img-container h-auto s-70 mx-auto mb-15">
                            <img src={process.env.PUBLIC_URL + "/assets/images/lock-password.png"} alt="" />
                        </div>
                        <div className="mb-2 d-flex flex-column align-items-center">
                            <p className='fs-20 heading lh-normal'>Password reset</p>
                            <p className='text fs-11 color-muted lh-normal text-center'>Your password has been successfully reset. <br /> Click below to log in.</p>
                        </div>
                        <div className="za_br_light pb-4 mb-4 br-bottom-1">
                            <button className="btn rounded btn-orange heading w-100" onClick={() => navigate("../", { replace: true })}>Continue</button>
                        </div>

                        <div className="d-flex align-items-center justify-content-center">
                            <p className='text fs-12 color-95 '>©{year} {ThemeConfiguration?.configuration?.company?.name}. All rights reserved</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ResetSuccessfull